import { hasValue } from '@r-and-a-shared-ui/utils';
import FormField, {
  BaseFormFieldProps,
  FormFieldProps,
} from '../FormField/FormField';
import { useFormContext } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { PASSWORD } from '../../constants';
import classNames from 'classnames';
import styles from './FormPasswordWithMultipleValidation.module.scss';

export type FormPasswordWithMultipleValidationProps = BaseFormFieldProps;

export const FormPasswordWithMultipleValidation = (
  props: FormPasswordWithMultipleValidationProps,
) => {
  const {
    fieldRef,
    isHidden,
    multipleValidation,
    multipleValidationLabel,
    subfields,
  } = props;

  const { watch } = useFormContext();

  const passwordField = subfields?.find(field => field.fieldType === PASSWORD);
  const password = watch(passwordField?.name || '');

  const patternResults =
    multipleValidation?.map(rule => {
      const regex = new RegExp(rule.regex || '');
      return {
        label: rule.validationMessage,
        passed: regex.test(password || ''),
      };
    }) || [];

  const displayMultipleValidationMessages = ():
    | React.JSX.Element
    | undefined => {
    if (!multipleValidation) return undefined;

    return (
      <div className={styles.validation}>
        <div className={styles.label}>{multipleValidationLabel}</div>
        {patternResults.map(rule => (
          <div
            key={rule.label}
            className={classNames(
              styles.rule,
              rule.passed ? styles.passed : '',
            )}
          >
            <FontAwesomeIcon icon={rule.passed ? faCheck : faXmark} size="sm" />
            <span>{rule.label}</span>
          </div>
        ))}
      </div>
    );
  };

  const renderFormFields = (
    fieldsProps: FormFieldProps[] | undefined,
  ): React.JSX.Element[] | null => {
    if (!hasValue(fieldsProps) || typeof fieldsProps === 'undefined') {
      return null;
    }

    return fieldsProps.map(fieldProps => {
      return <FormField {...fieldProps} key={fieldProps?.key} />;
    });
  };

  if (isHidden) {
    return null;
  }

  return (
    <div ref={fieldRef} className={styles.fields}>
      {renderFormFields(subfields)}
      {displayMultipleValidationMessages()}
    </div>
  );
};

export default FormPasswordWithMultipleValidation;
